import { render, staticRenderFns } from "./LostReason.vue?vue&type=template&id=02bc1ff3&"
import script from "./LostReason.vue?vue&type=script&lang=js&"
export * from "./LostReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports